import React, {useState} from 'react';
import Modal from 'react-modal';
import useOverlayParent from '../../../shared/hooks/useOverlayParent';

const dateLabel = value => value && !Number.isNaN(Date.parse(value))
  ? new Date(value).toLocaleString('pl-PL') : 'Brak informacji';

export default function VersionStatus({versionInfo, availableVersion, newVersionAvailable, reloadForNewVersion}) {
  const parent = useOverlayParent();
  const [details, setDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const reload = async force => {
    setDetails(true);
    setError('');
    setLoading(true);
    try {await reloadForNewVersion(force);}
    catch (cause) {setLoading(false); setError(cause.message || 'Nie udało się załadować wersji. Spróbuj ponownie.');}
  };
  return <>
    <div className="dashboard-version-status">
      <button type="button" className={`dashboard-version-hash${newVersionAvailable ? ' dashboard-version-hash-new' : ''}`}
        aria-label="Szczegóły wersji" title={newVersionAvailable ? 'Dostępna nowa wersja' : 'Wersja aplikacji'} onClick={() => setDetails(true)}>
        {String(versionInfo?.gitHash || 'development').slice(0, 7)}
      </button>
    </div>
    <Modal isOpen={details} onRequestClose={() => !loading && setDetails(false)}
      parentSelector={() => parent} aria={{modal: true}}
      appElement={document.getElementById('root') || undefined} ariaHideApp={parent === document.body && !!document.getElementById('root')}
      contentLabel={loading ? 'Ładowanie wersji' : 'Szczegóły wersji'}
      className={loading ? 'version-panel version-panel-loading' : 'version-panel'}
      overlayClassName="version-overlay" shouldCloseOnEsc={!loading} shouldCloseOnOverlayClick={!loading}>
      {loading ? <div role="status" aria-live="polite">
        <span className="version-spinner" aria-hidden="true"/>
        <h1>{newVersionAvailable ? 'Ładuję nową wersję…' : 'Przeładowuję aplikację…'}</h1>
        <p>Pobieram aplikację. Za chwilę strona otworzy się ponownie.</p>
      </div> : <>
        <h1>Wersja aplikacji</h1>
        <dl><dt>Uruchomiona wersja</dt><dd><code>{versionInfo?.gitHash || 'development'}</code></dd>
          <dt>Data kompilacji</dt><dd>{dateLabel(versionInfo?.buildTime)}</dd>
          <dt>Wersja na serwerze</dt><dd><code>{availableVersion?.gitHash || 'Nie sprawdzono'}</code></dd>
          <dt>Data kompilacji na serwerze</dt><dd>{dateLabel(availableVersion?.buildTime)}</dd></dl>
        {newVersionAvailable && <p>Dostępna jest nowa wersja.</p>}
        {error && <p className="version-error" role="alert">{error}</p>}
        <div className="version-actions">
          <button type="button" onClick={() => reload(false)}>{newVersionAvailable ? 'Załaduj nową wersję' : 'Przeładuj aplikację'}</button>
          <button type="button" onClick={() => reload(true)}>Wymuś przeładowanie</button>
          <button type="button" onClick={() => setDetails(false)}>Zamknij</button>
        </div>
        <p className="version-note">Wymuszenie pobiera aplikację od nowa. Śpiewniki i ustawienia pozostają zachowane.</p>
      </>}
    </Modal>
  </>;
}
